import { AddToUserDefinedProperty } from './helpers';
import { SET_INPUT_USER_DEFINED_PROPERTY } from './user-defined-property-keys';

export type SetInputMapEntry = { input: string, value: any };

export function SetInput<Input>(input: string, value: Input) {
  return function(target: any, propertyKey: string) {
    AddToUserDefinedProperty(target, propertyKey, SET_INPUT_USER_DEFINED_PROPERTY, { input, value } as SetInputMapEntry)
  }
}
